import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autosuggest from "react-autosuggest";
import { setCustomer, setCompany, setBillingInfo, setDeliveryInfo } from "state/orderEdition/actions";

const CustomerSelectComponent = () => {
  const dispatch = useDispatch();
  const customers = useSelector((state) =>
    state.adminData.customers ? state.adminData.customers : []
  );
  const companies = useSelector((state) =>
    state.adminData.companies ? state.adminData.companies : []
  );
  const billingInfo = useSelector(
    (state) => state.orderEdition.billingInfo
  );
  const selectedCustomer = useSelector((state) => state.orderEdition.customer);

  const [value, setValue] = useState(selectedCustomer?.lastname || "");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    setValue(selectedCustomer?.lastname || "");
  }, [selectedCustomer]);

  useEffect(() => {
    setSuggestions(getSuggestions(value));
  }, [customers]);

  // Dispatch également l'entreprise et les infos de facturation
  const handleCustomerSelect = (customer) => {
    dispatch(setCustomer(customer));
    let company = companies.find((company) => company.id === customer.company_id);
    if (company) {
      dispatch(setCompany(company));
    }
    if (customer) {
      const fullAddress = customer?.street_number + " " + customer?.street + " " + customer?.postal_code + " " + customer?.city;
      dispatch(setBillingInfo({
        ...billingInfo,
        lastname: customer?.lastname,
        firstname: customer?.firstname,
        phone: customer?.phone,
        addressComplement: customer?.address_complement || "",
        fullAddress: fullAddress,
        company: company?.name || billingInfo.company,
        streetNumber: customer?.street_number || "",
        street: customer?.street || "",
        postalCode: customer?.postal_code || "",
        city: customer?.city || "",
      }))
      // Vide les infos de livraison si changement de client
      dispatch(setDeliveryInfo({
        lastname: "",
        firstname: "",
        phone: "",
        phoneSecondary: "",
        addressComplement: "",
        fullAddress: "",
        company: "",
        streetNumber: "",
        street: "",
        postalCode: "",
        city: "",
      }))
    }
  };

  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : customers.filter((customer) =>
          `${customer.lastname}`.toLowerCase().includes(inputValue) ||
          `${customer.firstname}`.toLowerCase().includes(inputValue) ||
          `${customer.email}`.toLowerCase().includes(inputValue)
        );
  };

  const getSuggestionValue = (suggestion) =>
    `${suggestion.lastname} ${suggestion.firstname}`;

  const renderSuggestion = (suggestion) => (
    <div>{`${suggestion.lastname} ${suggestion.firstname} ${suggestion.email} (ID: ${suggestion.id})`}</div>
  );

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: "Recherche de client...",
    value,
    onChange: (event, { newValue }) => {
      setValue(newValue);
    },
  };

  const theme = {
    input: {
      display: "block",
      width: "100%",
      height: "calc(1.5em + .75rem + 2px)",
      padding: ".375rem .75rem",
      fontSize: "1rem",
      fontWeight: "400",
      lineHeight: "1.5",
      color: "#495057",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
      borderRadius: ".25rem",
      transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
    },
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      className="form-control"
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      onSuggestionSelected={(event, { suggestion }) =>
        handleCustomerSelect(suggestion)
      }
      theme={theme}
    />
  );
};

export default CustomerSelectComponent;
